import { render, staticRenderFns } from "./AuthError.vue?vue&type=template&id=6c88eecd&scoped=true"
import script from "./AuthError.vue?vue&type=script&lang=js"
export * from "./AuthError.vue?vue&type=script&lang=js"
import style0 from "./AuthError.vue?vue&type=style&index=0&id=6c88eecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88eecd",
  null
  
)

export default component.exports